export default __webpack_public_path__ + "static/media/inner-sustainability.40b6ab98.svg";